<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget :headerText="$t('management.customOs.uploadIso')">
          <CustomIsoUploadIso v-on:show="callToast($event)"/>
        </vuestic-widget>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget :headerText="$t('management.customOs.removeIso')">
          <div class="row">
            <div class="col-12 m-t-b-sm">
              <small>{{$t('management.customOs.removeIsoInfo')}}</small>
            </div>
            <div class="col-md-8 col-sm-8">
              <multiselect v-model="valueVersion" label="title" track-by="title"
                           :options="(isoImages !== null)? isoImages : []" :loading="isLoadinIso"
                           :option-height="104" :custom-label="customLabel" :show-labels="false">
                <template slot="singleLabel" slot-scope="props">
                  <span class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                  </span>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{ props.option.name }}</span>
                  </div>
                </template>
              </multiselect>
            </div>
            <div class="col-md-4 col-sm-4">
              <div class="btn btn-micro btn-primary">
                {{$t('management.customOs.removeIso')}}
              </div>
            </div>
          </div>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
  import CustomIsoUploadIso from "./CustomIsoUploadIso";
  import {getAxios} from 'services/ajax'

  export default {
    name: "CustomIsoSpace",
    data() {
      return {
        min: 1,
        max: 100,
        size: "100",
        type: "horizontal",
        valueUpload: 0,
        file: '',
        isoImages: [],
        valueVersion: null,
        valueAnimationInterval: 3000,
        showLoadBar: false,
        isLoadinIso: false
      }
    },
    created() {
      this.collectIsoImages()
    },
    methods: {
      customLabel({display_name}) {
        return `${display_name}`
      },
      callToast(data) {
        this.showToast(this.$t('management.customOs.' + data), {
          icon: 'fa-exclamation',
          position: 'top-center',
          duration: 3000,
          fullWidth: false
        })
      },
      collectIsoImages() {
        this.isLoadinIso = true
        this.isoImages = []

        getAxios().get('/custom_iso/' + this.serverId)
          .then(response => {
            this.isoImages.push({name: this.$t('management.customOs.selectImages.private'), $isDisabled: true})
            this.isoImages.push(...response.data.ServersIsoAction.data.private)
          })
          .catch(function () {
          })
          .finally(() => {
            this.isLoadinIso = false
          });
      },
    },
    components: {CustomIsoUploadIso}
  }
</script>

<style scoped lang="scss">
  small {
    font-size: 1rem;
  }

  .m-t-b-sm {
    margin-bottom: 15px;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomIso/CustomIsoSpace.vue